var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.distributorData
    ? _c("div", { staticClass: "child-view" }, [
        _c("div", { staticClass: "account-iframe__wrapper" }, [
          _c("iframe", {
            staticClass: "account-iframe__object",
            attrs: {
              src: _vm.src,
              type: "text/javascript",
              sandbox: "allow-scripts allow-same-origin allow-downloads"
            }
          })
        ]),
        _c(
          "a",
          {
            staticClass: "btn__back account-iframe__backbtn",
            attrs: { href: "#" },
            on: {
              cancel: function($event) {
                _vm.viewHistorial = false
              },
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [
            _c("span", { staticClass: "glicon-back-large-arrow" }),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    return _vm.$router.go(-1)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("actions.back")))]
            )
          ]
        )
      ])
    : _c("div", { staticClass: "main__void" }, [
        _vm._m(0),
        _c("span", { staticClass: "main__void--title" }, [
          _vm._v(_vm._s(_vm.$t("nouns.noDistributor")))
        ]),
        _c("span", { staticClass: "main__void--subtitle" })
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "main__void--icon" }, [
      _c("span", { staticClass: "glicon-axis-arrow" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }